import {mapMutations, mapActions, mapGetters} from "vuex";

//sections
import SmallLoader from "@/components/small-loader/index.vue";
import {loginByPhone} from "@/mixins/loginByPhone.js";

export default {
    name: "auth",
    components: {
        SmallLoader,
    },
    mixins: [loginByPhone],
    data() {
        return {
            selectedService: [],
        }
    },
    created() {
    },
    mounted() {

    },
    watch: {},
    computed: {
        ...mapGetters({})
    },
    methods: {
        ...mapMutations({
            setToken: 'auth/SET_TOKEN',
            closeRegisterPopup: 'auth/SHOW_REGISTER_POPUP',
            isShowAuthPopup: 'auth/SHOW_AUTH_POPUP'
        }),
        showRegisterPopup(){
            this.closeRegisterPopup(true)
            this.isShowAuthPopup(false)
        },
        ...mapActions({}),
    }
}
